import { useAuth, friendlyInviteError } from "../lib/auth";

/** The hosted site's gate: everything behind /dashboard/ requires a Guardius
 *  sign-in. Rendered instead of the studio whenever there is no token.
 *
 *  Two variants: the default showcase copy, and an "invited" variant shown when
 *  the boot flow captured a pending invite code (`?invite=...`). A failed
 *  pre-sign-in invite outcome (e.g. a malformed `?invite=`) renders its friendly
 *  message alongside any OAuth callback error. */
export function SignIn() {
  const { signIn, error, pendingInvite, inviteOutcome } = useAuth();
  const invited = pendingInvite !== null;
  const inviteFailed = inviteOutcome?.status === "failed";
  return (
    <div className="signin">
      <div className="signin-card">
        <div className="run-bar-brand">
          SAGA<span>studio</span>
        </div>
        {invited ? (
          <p>
            You've been invited to Saga Studio. Sign in to accept your invite — your access is
            granted automatically.
          </p>
        ) : (
          <p>
            Saga simulates autonomous agents whose interactions produce emergent stories. This
            showcase replays pre-baked runs of the shipped example scenarios — browse the
            definitions, scrub the replays, and follow a single settler's life.
          </p>
        )}
        <button className="btn btn-run" onClick={() => void signIn()}>
          {invited ? "Accept invite & sign in" : "Sign in with Guardius"}
        </button>
        {error && <div className="diagnostic">{error}</div>}
        {inviteFailed && <div className="diagnostic">{friendlyInviteError(inviteOutcome.reason)}</div>}
        <p className="signin-hint">
          Want to edit and run your own simulations? Run it locally:{" "}
          <code>uv run saga dashboard</code>
        </p>
      </div>
    </div>
  );
}
